import {NgModule} from '@angular/core';
import {RouterModule, Routes} from "@angular/router";
import {BookComponent} from "./book/book.component";
import {CatalogComponent} from "./catalog/catalog.component";
import {LoginComponent} from "./login/login.component";
import {ImprintComponent} from "./legal/imprint.component";
import {bookResolver} from "./routing/book.resolver";


const routes: Routes = [
  {
    path: '',
    component: CatalogComponent,
  },
  { path: 'edit/:id', component: BookComponent },
  { path: 'create', component: BookComponent },
  {
    path: ':category(book|novel|crime|erotic|historic|horror|romance|mystery|fantasy|thriller)/:id',
    component: CatalogComponent,
    resolve: { book: bookResolver }
  },

  // {
  //   matcher: bookMatcher,
  //   component: CatalogComponent,
  //   resolve: {
  //     book: bookResolver
  //   }
  // },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'imprint',
    component: ImprintComponent,
  },
];


@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule]
})



export class AppRoutingModule { }
